import { Controller } from 'stimulus';

export default class extends Controller {
  static values = { target: String }

  show(event) {
    $(this.targetValue).removeClass('hidden');
  }
}
